import { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Typography } from '@beeline/design-system-react/extracted-styles';

import { getCurrentDesk } from 'src/store/desks/selectors';

export const DeskBookingSidesheetTitle: FC = () => {
  const desk = useSelector(getCurrentDesk);

  const title = useMemo((): string => {
    return desk?.title ? `Рабочее место ${desk.title}` : 'Объект бронирования';
  }, [desk?.title]);

  return desk ? (
    <Typography ellipsis variant='h5' data-testid='bookingSideSheetTitle'>
      {title}
    </Typography>
  ) : null;
};
